import styled from 'styled-components';

const TableCommonWrapper = styled.div`
  margin: 0 0 1em;
  border: 1px solid ${props => props.theme.color.border};
  border-radius: 4px;

  .big-font {
    font-size: 1.5em;
    font-weight: bold;
    margin-left: 0.7em;
  }
  .last-name {
    text-transform: uppercase;
    font-weight: bold;
  }

  table {
    width: 100%;
    border-spacing: 0px;
    border: none;
    thead {
      font-size: 0.9em;
      background: ${props => props.theme.color.background};
      color: ${props => props.theme.color.label};
      td {
        padding: 0.8em 1em;
        text-transform: capitalize;
        position: relative;
        span {
          display: block;
          cursor: pointer;
          position: relative;
        }
        div {
          position: absolute;
          right: 1em;
          top: calc(50% - 8px);
          width: 7px;
          height: 16px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          svg:last-of-type {
            transform: rotate(180deg);
          }
        }
        &.active {
          svg path {
            fill: ${(p) => p.theme.color.label};
          }
          &.down div svg {
            &:first-of-type {
              display: none;
            }
          }
          &.up div svg {
            &:last-of-type {
              display: none;
            }
          }
        }
      }
    }

    tbody {
      tr {
        cursor: pointer;
        transition: opacity 0.25s ease-in-out;
        &:hover {
          opacity: 0.7;
        }
      }
    }

    td {
      border-top: 1px solid ${props => props.theme.color.border};
      padding: 1em;
      &:not(:last-of-type) {
        border-right: 1px solid ${props => props.theme.color.border};
      }
      &:nth-of-type(1) {
        /* time */
        width: 70px;
      }
      &:nth-of-type(2) {
        /* certificate */
        width: 125px;
      }
      &:nth-of-type(4),
      &:nth-of-type(5) {
        /* Injections */
        width: 125px;
      }

      &.zero {
        color: ${props => props.theme.color.label};
      }

      &.big-font {
        font-size: 1.2em;
        padding: 0.7em 0.8em;
      }
    }
  }
`;

const TableHeader = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 1.2em 1em;
`;

const TableName = styled.div`
  font-size: 1.5em;
`;

export default {
  TableCommonWrapper,
  TableHeader,
  TableName
};
